import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

// Ui libraries
import { MaterialModule } from './material.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { FileSaverModule } from 'ngx-filesaver';

import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

import { NgSelectModule } from '@ng-select/ng-select';

import { ImageCropperModule } from 'ngx-image-cropper';

// components - this will be removed if standalone is implemented, every component should be importented in the parent component
import { ConfirmDialogComponent } from './components/confirm-dialog.component';
import { CropImageComponent } from './components/crop-image/crop-image.component';
import { FormErrorsComponent } from './components/form-errors.component';
import { FormServerErrorsComponent } from './components/form-server-errors.component';
import { ItemDetailFormActionsComponent } from './components/item-detail-form-actions.component';
import { ListActionsComponent } from './components/list-actions.component';
import { MapComponent } from './components/map.component';
import { SearchFormActionsComponent } from './components/search-form-actions.component';
import { SearchFormExportsComponent } from './components/search-form-exports';
import { SearchClientInputComponent } from './components/search-client-input.component';
import { SearchProductInputComponent } from './components/search-product-input.component';
import { SearchProviderInputComponent } from './components/search-provider-input.component';
import { SearchTextInputComponent } from './components/search-text-input.component';
import { SortByComponent } from './components/sort-by.component';
import { SpinnerComponent } from './components/spinner.component';
import { SpinnerFormActionsComponent } from './components/spinner-form-actions.component';
import { TableFooterComponent } from './components/table-footer.component';
import { TranslationLanguageTitle } from './components/translation-language-title';
import { TranslationOptionsComponent } from './components/translation-options.component';

// directives
import { AllowPatternDirective } from './directives/allow-pattern.directive';
import { CurrencyFormatDirective } from './directives/currency-format.directive';
import { InputNumberMaxLengthDirective } from './directives/input-number-max-length.directive';
import { MapDirective } from './directives/map.directive';

// pipes
import { TimePipe } from './pipes/time.pipe';

@NgModule({
  declarations: [
    // components
    ConfirmDialogComponent,

    CropImageComponent,
    FormErrorsComponent,
    FormServerErrorsComponent,
    ItemDetailFormActionsComponent,
    ListActionsComponent,
    MapComponent,
    SearchClientInputComponent,
    SearchFormActionsComponent,
    SearchFormExportsComponent,
    SearchProductInputComponent,
    SearchProviderInputComponent,
    SearchTextInputComponent,
    SortByComponent,
    SpinnerComponent,
    SpinnerFormActionsComponent,
    TableFooterComponent,
    TranslationLanguageTitle,
    TranslationOptionsComponent,

    // directives
    AllowPatternDirective,
    CurrencyFormatDirective,
    InputNumberMaxLengthDirective,
    MapDirective,

    // pipes
    TimePipe,
  ],
  entryComponents: [
    // Needed if used in angularjs

    // components
    ConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    MaterialModule,
    GoogleMapsModule,
    FileSaverModule,
    NgxDaterangepickerMd.forRoot(),
    NgSelectModule,

    ImageCropperModule,
  ],
  exports: [
    // modules
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    MaterialModule,
    GoogleMapsModule,
    FileSaverModule,

    // components
    CropImageComponent,
    FormErrorsComponent,
    FormServerErrorsComponent,
    ItemDetailFormActionsComponent,
    ListActionsComponent,
    MapComponent,
    SearchClientInputComponent,
    SearchFormActionsComponent,
    SearchFormExportsComponent,
    SearchProductInputComponent,
    SearchProviderInputComponent,
    SearchTextInputComponent,
    SortByComponent,
    SpinnerComponent,
    SpinnerFormActionsComponent,
    TableFooterComponent,
    TranslationLanguageTitle,
    TranslationOptionsComponent,

    // directives
    AllowPatternDirective,
    CurrencyFormatDirective,
    InputNumberMaxLengthDirective,
    MapDirective,

    // pipes
    TimePipe,

    NgxDaterangepickerMd,
    NgSelectModule,
    ImageCropperModule,
  ],
})
export class SharedModule {}

// import { LanguageSelectorComponent } from './components/language-selector.component';
// LanguageSelectorComponent,
// LanguageSelectorComponent,
